import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {getVisualizationConfigGQLFromChartStep} from 'analysis-tool/data/StepConfigUtils';
import {assert} from 'Asserts';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {VISUALIZATION_TYPE_TO_PARAMETERS_TYPENAME} from 'insights/analytics-visualizations/AnalyticsVisualizationConstants';
import {
  VisualizationConfig,
  VisualizationType,
} from 'insights/universal-blocks/SharedUniversalBlockViewTypes';
import {PipelineStepConfig} from 'pipelines/PipelineTypes';
import {getPipelineStepConfig} from 'pipelines/StepShapeUtils';

export function getVisualizationConfigGQLForTableViewStep(
  stepId: string,
  config: PipelineStepConfig<PipelineStepType.TABLE_VIEW, 0>
): {
  visualizationConfig: VisualizationConfig;
  viewName: string;
} {
  return {
    viewName: config.viewName,
    visualizationConfig: {
      __typename: 'AnalyticsVisualizationNode',
      id: `stub-id-${stepId}`,
      parameters: {
        __typename: VISUALIZATION_TYPE_TO_PARAMETERS_TYPENAME[VisualizationType.TABLE],
        displayColumnsJson: null,
      } as VisualizationConfig['parameters'],
    },
  };
}

export default function getStepVisualizationConfigAndName(chartOrTableStep: GetAnalysisPipelineStep): {
  visualizationConfig: VisualizationConfig;
  viewName: string;
} {
  assert(
    [PipelineStepType.CHART_VIEW, PipelineStepType.TABLE_VIEW].includes(chartOrTableStep.definition.stepType),
    'Unexpected step type',
    {
      stepId: chartOrTableStep.id,
      stepType: chartOrTableStep.definition.stepType,
    }
  );

  if (chartOrTableStep.definition.stepType === PipelineStepType.CHART_VIEW) {
    const config = getVisualizationConfigGQLFromChartStep(chartOrTableStep);

    return {
      viewName: config.visualizationName,
      visualizationConfig: config.visualizationConfig,
    };
  } else {
    return getVisualizationConfigGQLForTableViewStep(
      chartOrTableStep.id,
      getPipelineStepConfig(chartOrTableStep, PipelineStepType.TABLE_VIEW, 0)
    );
  }
}
